"use client"

import { cn } from "@/lib/utils"

/**
 * Wrapper for the image background component that will be used in the auth split layout
 *
 * @param src - The source of the image
 * @param alt - The alt text of the image
 * @param className - The class name of the image
 * @returns A div with the image inside
 */
interface SplitImageWrapperProps {
  src: string
  alt?: string
  className?: string
}

export const SplitImageWrapper = ({
  src,
  alt = "Batyr community",
  className,
}: SplitImageWrapperProps) => (
  <div
    className={cn("relative size-full overflow-hidden rounded-2xl", className)}
  >
    <img src={src} alt={alt} className="size-full object-cover" />
  </div>
)
